export default __webpack_public_path__ + "static/media/walledited.a6a12b28.jpg";